import request from '@/utils/request'
const BASE_URL = '/InventoryPeriodBeginning'

//库存期初
export default {
  list(data) {
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data
    })
  },
  info(id) {
    return request({
      url: BASE_URL + '/Info',
      method: 'get',
      params: { id }
    })
  },
  save(data) {
    return request({
      url: BASE_URL + '/Save',
      method: 'post',
      data
    })
  },
  delete(data) {
    return request({
      url: BASE_URL + '/Delete',
      method: 'post',
      data
    })
  },
  review(data) {
    return request({
      url: BASE_URL + '/Review',
      method: 'post',
      data
    })
  },
  back(data) {
    return request({
      url: BASE_URL + '/Back',
      method: 'post',
      data
    })
  },
  //导入（库存期初）
  import: "/api" + BASE_URL + '/Import',
}